module.exports = __webpack_public_path__ + "8dfff44694ed7d84d9f8bc376c845a53.gif";